import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const integrations = [
  {
    name: 'Telegram',
    icon: 'ri-telegram-line',
    description: 'Основной канал — AI подключается к вашему Telegram-аккаунту и ведёт диалоги от вашего имени.',
  },
  {
    name: 'WhatsApp',
    icon: 'ri-whatsapp-line',
    description: 'AI работает через WhatsApp Business API — клиенты получают сообщения в привычном мессенджере.',
  },
  {
    name: 'MAX',
    icon: 'ri-smartphone-line',
    description: 'Поддержка платформы MAX для охвата дополнительной аудитории и точек входа.',
  },
];

const crms = [
  { name: 'amoCRM', icon: 'ri-database-2-line' },
  { name: 'Bitrix24', icon: 'ri-building-2-line' },
  { name: 'HubSpot', icon: 'ri-globe-line' },
  { name: 'Zoho', icon: 'ri-cloud-line' },
  { name: 'Pipedrive', icon: 'ri-bar-chart-2-line' },
  { name: 'Salesforce', icon: 'ri-rocket-line' },
];

export default function ASIntegrations() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { containerRef: channelsRef, revealedCount: channelsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);
  const { ref: crmTitleRef, revealed: crmTitleRevealed } = useScrollReveal();
  const { containerRef: crmsRef, revealedCount: crmsRevealed } = useScrollRevealGroup<HTMLDivElement>(6);

  return (
    <section className="py-16 md:py-24 bg-secondary-50/60">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16 max-w-[640px]">
          <span ref={labelRef} className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Интеграции
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            AI работает там,
            <br />
            где ваши клиенты
          </h2>
        </div>

        {/* Каналы */}
        <div ref={channelsRef} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-14">
          {integrations.map((ch, i) => (
            <div
              key={ch.name}
              className={`rounded-2xl bg-background-50 border border-background-200 p-6 md:p-7 reveal-fade-up ${i < channelsRevealed ? 'revealed' : ''}`}
              style={i < channelsRevealed ? { transitionDelay: `${i * 120}ms` } : undefined}
            >
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center text-primary-600 mb-4">
                <i className={`${ch.icon} text-lg`}></i>
              </div>
              <h3 className="font-display font-bold text-[16px] text-foreground-950 mb-2">
                {ch.name}
              </h3>
              <p className="text-[14.5px] text-foreground-500 leading-relaxed">{ch.description}</p>
            </div>
          ))}
        </div>

        {/* CRM */}
        <div className="rounded-2xl bg-background-50 border border-background-200 p-6 md:p-8">
          <h3 ref={crmTitleRef} className={`font-display font-bold text-[17px] text-foreground-950 mb-2 reveal-fade-up ${crmTitleRevealed ? 'revealed' : ''}`}>
            Интеграция с CRM
          </h3>
          <p className="text-[14.5px] text-foreground-500 mb-6 max-w-[560px]">
            Готовые лиды автоматически попадают в вашу CRM со всей историей переписки. Поддерживаем все популярные системы.
          </p>
          <div ref={crmsRef} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
            {crms.map((crm, i) => (
              <div
                key={crm.name}
                className={`flex items-center gap-2 px-3 py-2.5 rounded-lg bg-background-100 border border-background-200/50 reveal-fade-up ${i < crmsRevealed ? 'revealed' : ''}`}
                style={i < crmsRevealed ? { transitionDelay: `${i * 60}ms` } : undefined}
              >
                <span className="w-6 h-6 rounded-md bg-primary-100 flex items-center justify-center text-primary-600 shrink-0">
                  <i className={`${crm.icon} text-xs`}></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">
                  {crm.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}